import { Database, Q } from '@nozbe/watermelondb'
import { Observable } from '@nozbe/watermelondb/utils/rx'
import { ComponentMessageVO } from '@repo/types'
import { Chat, Message } from '../model'
import {
  addMessage as _addMessage,
  addMessagesInBatch as _addMessagesInBatch,
  deleteMessages as _deleteMessages
} from '../writers'

export class MessageRepository {
  database: Database

  constructor(database: Database) {
    this.database = database
  }

  async addMessage(chat: Chat, payload: ComponentMessageVO) {
    return _addMessage(chat, payload, this.database)
  }

  async addMessagesInBatch(chat: Chat, payload: ComponentMessageVO[]) {
    return _addMessagesInBatch(chat, payload, this.database)
  }

  async deleteMessages() {
    return _deleteMessages(this.database)
  }

  observeMessagesByChatId = (chatId: string, sortDirection?: 'asc' | 'desc'): Observable<Message[]> => {
    const messages = this.database.collections.get<Message>('messages')
    return messages
      .query(Q.where('chat_id', chatId), Q.sortBy('at', sortDirection === 'asc' ? Q.asc : Q.desc))
      .observe()
  }
}
